import Cookies from 'js-cookie';

export default function () {
    const headerBar = document.querySelector('#header-bar');
    const closeButton = document.querySelector('[data-headerbar-close]');
    if (!headerBar || !closeButton) return;

    closeButton.addEventListener('click', function () {
        headerBar.remove();
        Cookies.set('header_bar_closed', '1', { expires: 1 });
    });
}